import React from 'react'

const Footer = () => {
    return (

        <>
            <div className='footer'>

                <div className='foot'>
                    <h1>Location</h1>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d28495.67170623725!2d80.985358!3d26.777578!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bfb82324729c5%3A0xe9a763e42036ca6!2sMedanta%20Super%20Speciality%20Hospital%2C%20Lucknow!5e0!3m2!1sen!2sin!4v1735835213636!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>

                <div className='foot'>
                    <h1>Facility</h1>
                    <p>Cutting-edge Diagnostic</p>
                    <p>Modern Dialysis Units</p>
                    <p>State-of-the-Art Operating Rooms</p>
                    <p>Specialized Nephrology Intensive Care Units</p>

                </div>

                <div className='foot'>
                    <h1>Treatment</h1>
                    <p>Chronic Kidney Disease</p>
                    <p>Dialysis Services</p>
                    <p>Kidney Transplantation</p>
                    <p>Acute Kidney Injury</p>
                    <p>Glomerular Diseases Treatment</p>

                </div>

                <div className='foot'>
                    <h1>Reach Us</h1>
                    <p>Contact: +91 9415026762</p>
                    <p>Sector - A, Pocket - 1, Amar Shaheed Path, Golf City, Lucknow Uttar Pradesh 226030</p>
                    <p>rksnepho206@gmail.com</p>

                </div>

            </div>


            <div className='disclamer'>
                @ 2024 Prof. Dr. R.K. Sharma Designed by Creative Digital World
            </div>


        </>
    )
}

export default Footer